import * as occlTemplates from './occl';
import * as tefOneTemplates from './tefOne';

let instance: TemplateResolver;

type TemplatesType = typeof tefOneTemplates;

const templates = {
  occl: occlTemplates as unknown as TemplatesType,
  tefOne: tefOneTemplates,
};

export type TemplateNames = keyof typeof tefOneTemplates;

export default class TemplateResolver {
  private occl: boolean;

  private constructor(occl: boolean) {
    this.occl = occl;
  }

  resolve<TN extends TemplateNames>(templateName: TN): typeof tefOneTemplates[TN] {
    return this.occl ? templates.occl[templateName] : templates.tefOne[templateName];
  }

  static getInstance(occl?: boolean) {
    if (!instance) {
      instance = new TemplateResolver(occl);
    }
    return instance;
  }
}
